import React, {useEffect, useState} from 'react'
import axios from "axios";
import ExploradorMedios from "../../../../../pages/Medios/ExploradorMedios/ExploradorMedios.jsx";
import "/src/pages/Profile/Profile.css"
import ExploradorModelos3D from "./ExploradorModelos3d.jsx";

const SelectorProducto = ({item, handleChange}) => {


    const onModeloSelect = (modelo3d) => {
        // console.log("Modelo seleccionado", modelo3d.id);
        handleChange({
            target: {
                name: 'keyring',
                value: modelo3d.id
            }
        })
    }

    return (
        <div className="grid grid-cols-1 grid-rows-6 gap-4 bg-gray-800 p-2 rounded-lg shadow-lg h-full w-full">
            <div className="font-sans col-span-1 row-span-1 bg-gray-700  bg-opacity-50 rounded-lg shadow-lg flex items-center justify-center">
                <label className="block text-gray-700 dark:text-gray-300 text-lg font-semibold mb-2">
                    Producto
                </label>

                <input
                    name="keyring"
                    value={item.keyring}
                    onChange={onModeloSelect}
                    className="hidden" // Clase para ocultar el input
                    type="text"
                    placeholder="Nombre del Producto"
                />
            </div>

            <div className="font-sans col-span-1 row-span-6 bg-gray-700  bg-opacity-50 rounded-lg shadow-lg flex items-center justify-center">


                <div className="overflow-y-auto w-full h-full min-h-full scrollbar_mod font-sans  p-3">
                    <ExploradorModelos3D onModeloSelect={onModeloSelect} showFilters={false} item={item} />
                </div>
            </div>
        </div>

    )
}
export default SelectorProducto
